var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "justify": "end",
      "align": "center"
    }
  }, [!_vm.accessToken ? [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "grey-13"
    }
  }, [_c('span', {
    staticClass: "font-size-lg-18 font-weight-bold",
    on: {
      "click": function click($event) {
        _vm.$refs['dialog-join'].shows = true;
      }
    }
  }, [_vm._v("회원가입")])])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "grey-d",
    staticStyle: {
      "min-height": "16px"
    },
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.$refs['dialog-login'].shows = true;
      }
    }
  }, [_c('span', {
    staticClass: "font-size-lg-18 font-weight-bold"
  }, [_vm._v("로그인")])])], 1)] : [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "grey-13"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('span', {
    staticClass: "font-size-lg-18 font-weight-bold"
  }, [_vm._v("로그아웃")])])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "href": "/dashboard"
    }
  }, [_c('span', {
    staticClass: "font-size-lg-18 font-weight-bold"
  }, [_vm._v("대시보드")])])], 1)], _c('dialog-login', {
    ref: "dialog-login"
  }), _c('dialog-join', {
    ref: "dialog-join"
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }